import { PRODUCT_TYPE } from "@erp/shared/types/product.types";
export const mockStockProducts = {
    items: [
        {
            id: 1,
            productCode: "RM-AL-0001",
            type: PRODUCT_TYPE.원부자재,
            classificationId: 101,
            classification: "알루미늄",
            manufacturerId: 201,
            manufacturer: "PION Metals",
            model: "AL-6061",
            name: "알루미늄 6061 바",
            spec: "Ø20 x 1000",
            directlyWritten: 0,
            conditions: "G",
            images: [],
            spotId: 1,
            spot: "A-01-01",
            stockNum: 120,
            latestStockDate: "2025-10-23T19:00:00.000Z",
            unitPrice: 1500,
            maxUnitPrice: 1800,
            minUnitPrice: 1200,
            quantityUnit: "EA",
            totalPrice: 120 * 1500,
        },
        {
            id: 2,
            productCode: "SEMI-PCB-0007",
            type: PRODUCT_TYPE.반제품,
            classificationId: 301,
            classification: "PCB",
            manufacturerId: 401,
            manufacturer: "PION Electronics",
            model: "PCB-V2",
            name: "컨트롤러 PCB V2",
            spec: "4-Layers",
            directlyWritten: 0,
            conditions: "G",
            images: [],
            spotId: 2,
            spot: "B-02-01",
            stockNum: 50,
            latestStockDate: "2025-10-23T19:00:00.000Z",
            unitPrice: 32000,
            maxUnitPrice: 35000,
            minUnitPrice: 30000,
            quantityUnit: "EA",
            totalPrice: 50 * 32000,
        },
        {
            id: 3,
            productCode: "FG-CTRL-0010",
            type: PRODUCT_TYPE.완제품,
            classificationId: 501,
            classification: "컨트롤러",
            manufacturerId: 601,
            manufacturer: "PION",
            model: "CTRL-10",
            name: "산업용 컨트롤러 10",
            spec: "IP54",
            directlyWritten: 0,
            conditions: "B",
            images: [],
            spotId: 3,
            spot: "C-03-01",
            stockNum: 0,
            latestStockDate: "2025-10-23T19:00:00.000Z",
            unitPrice: 980000,
            maxUnitPrice: 1000000,
            minUnitPrice: 950000,
            quantityUnit: "EA",
            totalPrice: 0,
        },
        {
            id: 4,
            productCode: "RM-ST-0002",
            type: PRODUCT_TYPE.원부자재,
            classificationId: 102,
            classification: "강철",
            manufacturerId: 202,
            manufacturer: "Steel Corp",
            model: "ST-304",
            name: "스테인리스강 304 플레이트",
            spec: "1000 x 2000 x 3T",
            directlyWritten: 0,
            conditions: "G",
            images: [],
            spotId: 1,
            spot: "A-01-02",
            stockNum: 25,
            latestStockDate: "2025-10-23T19:00:00.000Z",
            unitPrice: 8500,
            maxUnitPrice: 9000,
            minUnitPrice: 8000,
            quantityUnit: "EA",
            totalPrice: 25 * 8500,
        },
        {
            id: 5,
            productCode: "RM-CU-0003",
            type: PRODUCT_TYPE.원부자재,
            classificationId: 103,
            classification: "구리",
            manufacturerId: 203,
            manufacturer: "Copper Ltd",
            model: "CU-101",
            name: "구리 와이어",
            spec: "Ø2.0 x 100m",
            directlyWritten: 0,
            conditions: "G",
            images: [],
            spotId: 1,
            spot: "A-01-03",
            stockNum: 150,
            latestStockDate: "2025-10-23T19:00:00.000Z",
            unitPrice: 1200,
            maxUnitPrice: 1300,
            minUnitPrice: 1100,
            quantityUnit: "EA",
            totalPrice: 150 * 1200,
        },
        {
            id: 6,
            productCode: "SEMI-CASE-0008",
            type: PRODUCT_TYPE.반제품,
            classificationId: 302,
            classification: "케이스",
            manufacturerId: 402,
            manufacturer: "Case Works",
            model: "CASE-AL",
            name: "알루미늄 케이스",
            spec: "200 x 150 x 50",
            directlyWritten: 0,
            conditions: "G",
            images: [],
            spotId: 2,
            spot: "B-02-02",
            stockNum: 30,
            latestStockDate: "2025-10-23T19:00:00.000Z",
            unitPrice: 45000,
            maxUnitPrice: 48000,
            minUnitPrice: 42000,
            quantityUnit: "EA",
            totalPrice: 30 * 45000,
        },
        {
            id: 7,
            productCode: "SEMI-CABLE-0009",
            type: PRODUCT_TYPE.반제품,
            classificationId: 303,
            classification: "케이블",
            manufacturerId: 403,
            manufacturer: "Cable Tech",
            model: "CBL-USB",
            name: "USB 케이블",
            spec: "USB-C 2m",
            directlyWritten: 0,
            conditions: "B",
            images: [],
            spotId: 2,
            spot: "B-02-03",
            stockNum: 200,
            latestStockDate: "2025-10-23T19:00:00.000Z",
            unitPrice: 3500,
            maxUnitPrice: 3800,
            minUnitPrice: 3200,
            quantityUnit: "EA",
            totalPrice: 200 * 3500,
        },
        {
            id: 8,
            productCode: "FG-SENSOR-0011",
            type: PRODUCT_TYPE.완제품,
            classificationId: 502,
            classification: "센서",
            manufacturerId: 602,
            manufacturer: "Sensor Pro",
            model: "SENS-TEMP",
            name: "온도 센서",
            spec: "-40°C ~ +125°C",
            directlyWritten: 0,
            conditions: "G",
            images: [],
            spotId: 3,
            spot: "C-03-02",
            stockNum: 15,
            latestStockDate: "2025-10-23T19:00:00.000Z",
            unitPrice: 25000,
            maxUnitPrice: 27000,
            minUnitPrice: 23000,
            quantityUnit: "EA",
            totalPrice: 15 * 25000,
        },
        {
            id: 9,
            productCode: "FG-MOTOR-0012",
            type: PRODUCT_TYPE.완제품,
            classificationId: 503,
            classification: "모터",
            manufacturerId: 603,
            manufacturer: "Motor Inc",
            model: "MOT-STEP",
            name: "스테핑 모터",
            spec: "1.8° 2A",
            directlyWritten: 0,
            conditions: "G",
            images: [],
            spotId: 3,
            spot: "C-03-03",
            stockNum: 8,
            latestStockDate: "2025-10-23T19:00:00.000Z",
            unitPrice: 45000,
            maxUnitPrice: 48000,
            minUnitPrice: 42000,
            quantityUnit: "SET",
            totalPrice: 8 * 45000,
        },
        {
            id: 10,
            productCode: "RM-PL-0004",
            type: PRODUCT_TYPE.원부자재,
            classificationId: 104,
            classification: "플라스틱",
            manufacturerId: 204,
            manufacturer: "Plastic Co",
            model: "PL-ABS",
            name: "ABS 플라스틱 시트",
            spec: "500 x 1000 x 2T",
            directlyWritten: 0,
            conditions: "B",
            images: [],
            spotId: 1,
            spot: "A-01-04",
            stockNum: 40,
            latestStockDate: "2025-10-23T19:00:00.000Z",
            unitPrice: 8000,
            maxUnitPrice: 8500,
            minUnitPrice: 7500,
            quantityUnit: "EA",
            totalPrice: 40 * 8000,
        },
        {
            id: 11,
            productCode: "SEMI-SCREW-0010",
            type: PRODUCT_TYPE.반제품,
            classificationId: 304,
            classification: "나사",
            manufacturerId: 404,
            manufacturer: "Screw Master",
            model: "SCREW-M6",
            name: "M6 나사",
            spec: "M6 x 20",
            directlyWritten: 0,
            conditions: "G",
            images: [],
            spotId: 2,
            spot: "B-02-04",
            stockNum: 500,
            latestStockDate: "2025-10-23T19:00:00.000Z",
            unitPrice: 50,
            maxUnitPrice: 60,
            minUnitPrice: 45,
            quantityUnit: "EA",
            totalPrice: 500 * 50,
        },
        {
            id: 12,
            productCode: "FG-DISPLAY-0013",
            type: PRODUCT_TYPE.완제품,
            classificationId: 504,
            classification: "디스플레이",
            manufacturerId: 604,
            manufacturer: "Display Tech",
            model: "LCD-7",
            name: "7인치 LCD 디스플레이",
            spec: "800x480 RGB",
            directlyWritten: 0,
            conditions: "B",
            images: [],
            spotId: 3,
            spot: "C-03-04",
            stockNum: 5,
            latestStockDate: "2025-10-23T19:00:00.000Z",
            unitPrice: 120000,
            maxUnitPrice: 130000,
            minUnitPrice: 110000,
            quantityUnit: "SET",
            totalPrice: 5 * 120000,
        },
    ],
    totalStock: 120 + 50 + 0 + 25 + 150 + 30 + 200 + 15 + 8 + 40 + 500 + 5,
    totalPrice: 120 * 1500 +
        50 * 32000 +
        0 +
        25 * 8500 +
        150 * 1200 +
        30 * 45000 +
        200 * 3500 +
        15 * 25000 +
        8 * 45000 +
        40 * 8000 +
        500 * 50 +
        5 * 120000,
    total: 12,
    limit: 20,
    page: 1,
    pageCount: 1,
};
